import _ from 'lodash'
import { Component } from '@wix/thunderbolt-becky-types'
import { REDUCE_FUNCTIONS, toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { isRefArray } from '../../utils/variantsUtils'
import { getResponsiveItemLayouts } from '../../utils/responsiveLayoutUtils'

export const compLayouts = createCssCompNode('responsiveLayout', 'compLayouts', {
	getDependencies: (component: Component, refs: FeatureRefs<'responsiveLayout'>) =>
		component.layoutQuery ? refs.layoutQuery(component.layoutQuery) : undefined,
	toViewItem: (__, refArray) =>
		isRefArray(refArray)
			? toBreakpointVariantsMap(refArray.values, getResponsiveItemLayouts, REDUCE_FUNCTIONS.concat)
			: null,
})

export const editorCompLayouts = createCssCompNode('responsiveLayout', 'compLayouts', {
	getDependencies: (component: Component, refs: FeatureRefs<'responsiveLayout'>) =>
		component.layoutQuery
			? {
					refArray: refs.layoutQuery(component.layoutQuery),
					activeVariant: envRefs.activeVariant,
					activeBreakpoints: envRefs.activeBreakpoints,
					computeOnlyActiveBps: envRefs.experiment('specs.thunderbolt.compute_css_by_active_breakpoints'),
			  }
			: undefined,
	toViewItem: (__, deps) => {
		const { refArray, activeVariant, activeBreakpoints, computeOnlyActiveBps } = deps || {}

		if (!isRefArray(refArray)) {
			return null
		}
		const breakpointVariantsMap = toBreakpointVariantsMap(
			refArray.values,
			getResponsiveItemLayouts,
			REDUCE_FUNCTIONS.concat
		)

		if (activeVariant) {
			const defaultVariants = _.pick(breakpointVariantsMap.default, ['', activeVariant])
			return { default: defaultVariants }
		}

		const activeBreakpointsIds = _.keys(activeBreakpoints)
		const shouldFilterActiveBps = computeOnlyActiveBps && activeBreakpointsIds.length > 0

		if (shouldFilterActiveBps) {
			return _.pick(breakpointVariantsMap, ['default', ...activeBreakpointsIds])
		}

		return breakpointVariantsMap
	},
})
